
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curi-lunch",
      function () {
        return require("private-next-pages/curi-lunch/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curi-lunch"])
      });
    }
  